var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalVolume(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#454CF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.285V6H15.285V15.285H6ZM6 18V16.8596H7.14035V18H6ZM8.715 18V16.8596H9.85518V18H8.715ZM11.4298 18V16.8596H12.5702V18H11.4298ZM14.1448 18V16.8596H15.285V18H14.1448ZM16.8596 18V16.8596H18V18H16.8596ZM16.8596 15.285V14.1448H18V15.285H16.8596ZM16.8596 12.5702V11.4298H18V12.5702H16.8596ZM16.8596 9.85518V8.715H18V9.85518H16.8596ZM16.8596 7.14035V6H18V7.14035H16.8596Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalVolume);
export default __webpack_public_path__ + "static/media/total_volume.50b5858773ea9dcffa949fa9fee87e12.svg";
export { ForwardRef as ReactComponent };